/* ==========================================================================
   Custom mobile sidebar drawer.

   Vanilla ES (no jQuery, no React, no build step). Loaded with `defer`, so the
   DOM is parsed before this runs. Owns: open/close, body scroll-lock, focus
   trap, accordion submenus, and live search (theme view=json). Independent of
   the legacy index.js bundle — it never touches #mobile-nav / #search / React.
   ========================================================================== */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-sidebar]');
  if (!drawer) return;

  var panel = drawer.querySelector('[data-sidebar-panel]');
  var overlay = drawer.querySelector('[data-sidebar-overlay]');
  var closeBtn = drawer.querySelector('[data-sidebar-close]');
  var trigger = document.querySelector('[data-sidebar-open]');
  var nav = drawer.querySelector('.sidebar-drawer__nav');
  var mainContent =
    document.getElementById('page-wrapper') ||
    document.getElementById('root') ||
    document.querySelector('main');

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  // This storefront is Arabic (rtl) or English (ltr) only, so dir maps 1:1 to locale.
  var isRTL = document.documentElement.getAttribute('dir') === 'rtl';
  var lang = isRTL ? 'ar' : 'en';
  var STRINGS = {
    en: { empty: 'No results found', error: 'Something went wrong', loading: 'Searching…' },
    ar: { empty: 'لا توجد نتائج', error: 'حدث خطأ ما', loading: 'جارٍ البحث…' },
  };
  var t = STRINGS[lang];

  var lastFocused = null;

  /* ----------------------------------------------------------------------
     Open / close
     ---------------------------------------------------------------------- */
  function open() {
    if (drawer.classList.contains('is-open')) return;
    lastFocused = document.activeElement;
    drawer.hidden = false;
    // Force reflow so the transform transition runs from the hidden state.
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    document.body.classList.add('sidebar-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    if (mainContent) mainContent.setAttribute('aria-hidden', 'true');
    document.addEventListener('keydown', onKeydown);
    // Focus the close button (first interactive control) once visible.
    window.requestAnimationFrame(function () {
      if (closeBtn) closeBtn.focus();
    });
  }

  function close() {
    if (!drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('sidebar-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (mainContent) mainContent.removeAttribute('aria-hidden');
    document.removeEventListener('keydown', onKeydown);

    var done = function () {
      drawer.hidden = true;
      panel.removeEventListener('transitionend', done);
    };
    panel.addEventListener('transitionend', done);
    // Fallback in case transitionend doesn't fire (reduced motion, etc.).
    window.setTimeout(function () {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
    }, 400);

    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  function onKeydown(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      close();
      return;
    }
    if (e.key === 'Tab') trapFocus(e);
  }

  function trapFocus(e) {
    var nodes = Array.prototype.slice.call(panel.querySelectorAll(FOCUSABLE)).filter(function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  if (trigger) trigger.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (overlay) overlay.addEventListener('click', close);

  /* ----------------------------------------------------------------------
     Accordion submenus
     ---------------------------------------------------------------------- */
  if (nav) {
    // Strip the server-rendered `hidden` so CSS max-height can animate.
    Array.prototype.forEach.call(
      nav.querySelectorAll('.sidebar-nav__submenu[hidden]'),
      function (ul) {
        ul.hidden = false;
      },
    );

    nav.addEventListener('click', function (e) {
      var btn = e.target.closest('.sidebar-nav__toggle');
      if (!btn || !nav.contains(btn)) return;
      var item = btn.closest('.sidebar-nav__item--parent');
      if (!item) return;
      var expanded = item.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  /* ----------------------------------------------------------------------
     Search (theme's /search?...&view=json template).

     The store rejects Shopify predictive search (/search/suggest.json) on the
     primary Arabic locale ("Unsupported buyer locale", HTTP 417), so we use the
     theme's own JSON search view, which works on every locale. It returns:
       { "results_count": N, "results": [ { title, id, price (cents), url,
                                            thumbnail, tags } ] }
     ---------------------------------------------------------------------- */
  var searchInput = drawer.querySelector('[data-sidebar-search-input]');
  var resultsBox = drawer.querySelector('[data-sidebar-search-results]');

  if (searchInput && resultsBox && window.fetch) {
    var searchUrl = resultsBox.getAttribute('data-search-url') || '/search';
    var moneyFormat = resultsBox.getAttribute('data-money-format') || '{{amount}}';
    var controller = null;
    var debounceTimer = null;

    var setState = function (cls) {
      resultsBox.classList.remove('is-loading', 'is-empty');
      if (cls) resultsBox.classList.add(cls);
    };

    var clearResults = function () {
      resultsBox.innerHTML = '';
      setState(null);
    };

    var escapeHtml = function (str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    };

    // Minimal Shopify money formatter (handles the {{amount*}} placeholders).
    var formatMoney = function (cents) {
      var match = /\{\{\s*(\w+)\s*\}\}/.exec(moneyFormat);
      var key = match ? match[1] : 'amount';
      var decimals = key.indexOf('no_decimals') !== -1 ? 0 : 2;
      var useComma = key.indexOf('comma_separator') !== -1;
      var useSpace = key.indexOf('space_separator') !== -1;
      var thousands = useSpace ? ' ' : useComma ? '.' : ',';
      var decimal = useComma || useSpace ? ',' : '.';
      var parts = (Number(cents) / 100).toFixed(decimals).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      var value = parts[1] ? whole + decimal + parts[1] : whole;
      return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, value);
    };

    var resultHtml = function (item) {
      var img = item.thumbnail
        ? '<img class="sidebar-search__result-img" src="' +
          escapeHtml(item.thumbnail) +
          '" alt="" loading="lazy" />'
        : '<span class="sidebar-search__result-img"></span>';
      var price =
        item.price != null
          ? '<span class="sidebar-search__result-price">' + formatMoney(item.price) + '</span>'
          : '';
      return (
        '<a class="sidebar-search__result" href="' +
        escapeHtml(item.url) +
        '">' +
        img +
        '<span class="sidebar-search__result-body">' +
        '<span class="sidebar-search__result-title">' +
        escapeHtml(item.title) +
        '</span>' +
        price +
        '</span></a>'
      );
    };

    var render = function (data) {
      var items = (data && data.results) || [];
      if (!items.length) {
        resultsBox.textContent = t.empty;
        setState('is-empty');
        return;
      }
      resultsBox.innerHTML = items.map(resultHtml).join('');
      setState(null);
    };

    var runSearch = function (query) {
      if (controller) controller.abort();
      controller = new AbortController();

      var url = searchUrl + '?q=' + encodeURIComponent(query) + '&type=product&view=json';

      resultsBox.textContent = t.loading;
      setState('is-loading');

      fetch(url, { signal: controller.signal })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text(); // view=json is served as text/html with a JSON body
        })
        .then(function (text) {
          var data;
          try {
            data = JSON.parse(text);
          } catch (e) {
            throw new Error('bad json');
          }
          render(data);
        })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          resultsBox.textContent = t.error;
          setState('is-empty');
        });
    };

    searchInput.addEventListener('input', function () {
      var query = searchInput.value.trim();
      window.clearTimeout(debounceTimer);
      if (query.length < 2) {
        if (controller) controller.abort();
        clearResults();
        return;
      }
      debounceTimer = window.setTimeout(function () {
        runSearch(query);
      }, 250);
    });

    // Clear results when the drawer closes so they don't persist between opens.
    if (closeBtn) closeBtn.addEventListener('click', clearResults);
    if (overlay) overlay.addEventListener('click', clearResults);
  }
})();
